import React from 'react';

const TaskQuestionBox = ({children, className, innerClassName}) => (
    <div className={`task-question-box ${className}`}>
        <div className={innerClassName} style={{textAlign: 'center', width: '100%'}} dangerouslySetInnerHTML={children}>
            {/*children*/}
        </div>
    </div>
)

export default TaskQuestionBox;